module.exports = __webpack_public_path__ + "img/audio.458b1e29.png";